import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import PatientJourney from './data/overview_data.js/patientJourney';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    boxSizing: 'border-box',
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
  },
  loading: {
    width: '100%',
    height: '100vh',
    display: 'grid',
    placeItems: 'center',
    background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
  },
  shell: {
    minHeight: 'calc(100vh - 32px)',
    borderRadius: 14,
    overflow: 'hidden',
    background: '#fff',
    boxShadow: '0 12px 30px rgba(0, 45, 85, 0.08)',
  },
}));

export default function PatientFeedback() {
  const token = useSelector((state) => state.auth.token);
  const classes = useStyles();
  const [completedSessionsList, setCompletedSessionsList] = useState([]);
  const [phaseProgress, setPhaseProgress] = useState(0);
  const [phaseTitle, setPhaseTitle] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadFeedback = async () => {
      const selectedTreatmentId = typeof window !== 'undefined'
        ? window.localStorage.getItem('vp_selectedTreatmentId')
        : '';

      if (!selectedTreatmentId || !token) {
        if (!cancelled) {
          setLoading(false);
        }
        return;
      }

      try {
        const headers = {
          Authorization: `Token ${token}`,
          Accept: 'application/json',
        };

        const [phaseRes, sessionsRes] = await Promise.all([
          fetch(`${BACKEND_URL}/treatment/phase/progress/treatment/${selectedTreatmentId}/`, { headers }),
          fetch(`${BACKEND_URL}/treatment/sessions/all/treatment/${selectedTreatmentId}/`, { headers }),
        ]);

        const [phaseData, sessionsData] = await Promise.all([
          phaseRes.ok ? phaseRes.json() : Promise.resolve({}),
          sessionsRes.ok ? sessionsRes.json() : Promise.resolve({ sessions: [] }),
        ]);

        if (cancelled) {
          return;
        }

        setPhaseProgress(phaseData?.progress ?? 0);
        setPhaseTitle(phaseData?.name || phaseData?.phase_name || '');
        setCompletedSessionsList(Array.isArray(sessionsData?.sessions) ? sessionsData.sessions : []);
      } catch (error) {
        if (!cancelled) {
          setPhaseTitle('');
          setCompletedSessionsList([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    void loadFeedback();

    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <Box className={classes.loading}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.shell}>
        <Typography style={{ display: 'none' }}>Patient feedback</Typography>
        <PatientJourney
          progress={phaseProgress}
          title={phaseTitle}
          completedSessionsList={completedSessionsList}
          planned_sessions_per_day_overall={3}
          plannedSessionsPerDay={3}
        />
      </Box>
    </Box>
  );
}
